var map = {
	"./check.png": 71392,
	"./ciencias-politicas.png": 84642,
	"./citas.png": 57753,
	"./clip.png": 60485,
	"./codigo.png": 21177,
	"./cuadricula.png": 53453,
	"./derecho.png": 1705,
	"./descarga.png": 38303,
	"./dual.png": 86872,
	"./editar.png": 29156,
	"./estadisticas.png": 53772,
	"./fisica.png": 3961,
	"./fluid.png": 35279,
	"./indice.png": 80913,
	"./ingenieria.png": 71359,
	"./justicia.png": 43051,
	"./libros.png": 3983,
	"./lupa.png": 77457,
	"./marcador.png": 72198,
	"./miniatura.png": 94399,
	"./notacompartida.png": 53205,
	"./notaprivada.png": 14101,
	"./noti.png": 27084,
	"./revistas.png": 96541,
	"./robotica.png": 92065,
	"./single.png": 26025,
	"./video.png": 81904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60688;